import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Briefcase, LogOut, LayoutDashboard, ShieldCheck, ChevronDown, GraduationCap, BookOpenCheck, MessageSquareText } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const closeCandidateMenu = (event) => {
    const details = event.currentTarget.closest("details");
    if (details) details.removeAttribute("open");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200">
      <nav className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 min-w-0">
          <span className="bg-gradient-to-r from-blue-700 to-indigo-900 text-white w-9 h-9 rounded-xl grid place-items-center shrink-0">
            <Briefcase size={18} />
          </span>
          <span className="font-heading font-extrabold tracking-tight text-lg text-slate-950 leading-none truncate">
            Vagas Campinas<span className="hidden lg:inline"> e Região</span>
          </span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/" data-testid="nav-vagas" className="hidden md:block font-semibold text-slate-700 hover:text-slate-950 px-3 py-2">
            Vagas
          </Link>

          <details className="relative group">
            <summary className="list-none cursor-pointer font-semibold text-slate-700 hover:text-slate-950 px-3 py-2 rounded-lg hover:bg-slate-100 flex items-center gap-1">
              Candidatos <ChevronDown size={15} />
            </summary>
            <div className="absolute right-0 mt-2 w-72 bg-white border border-slate-200 rounded-2xl shadow-xl p-2">
              <Link onClick={closeCandidateMenu} to="/vaga-limpa" className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50">
                <ShieldCheck size={19} className="text-emerald-600 mt-0.5" />
                <span><strong className="block text-slate-950">VagaLimpa</strong><small className="text-slate-500">Confira a transparência do anúncio</small></span>
              </Link>
              <Link onClick={closeCandidateMenu} to="/primeiro-emprego" className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50">
                <GraduationCap size={19} className="text-blue-600 mt-0.5" />
                <span><strong className="block text-slate-950">Primeiro Emprego</strong><small className="text-slate-500">Oportunidades para quem está começando</small></span>
              </Link>
              <Link onClick={closeCandidateMenu} to="/estagios" className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50">
                <BookOpenCheck size={19} className="text-emerald-600 mt-0.5" />
                <span><strong className="block text-slate-950">Estágio Limpo</strong><small className="text-slate-500">Estágio e aprendizagem em um só lugar</small></span>
              </Link>
              <Link onClick={closeCandidateMenu} to="/entrevista-treino" className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50">
                <MessageSquareText size={19} className="text-violet-600 mt-0.5" />
                <span><strong className="block text-slate-950">Entrevista Treino</strong><small className="text-slate-500">Pratique sem API paga</small></span>
              </Link>
            </div>
          </details>

          <Link to="/planos" data-testid="nav-planos" className="hidden sm:block font-semibold text-slate-700 hover:text-slate-950 px-3 py-2">
            Divulgar vaga
          </Link>

          {!user && (
            <Link
              to="/login"
              data-testid="nav-login"
              className="bg-slate-950 text-white font-bold px-4 py-2 rounded-xl hover:bg-slate-800 transition-colors"
            >
              Entrar
            </Link>
          )}

          {user && user.role === "company" && (
            <Link to="/empresa" data-testid="nav-empresa" className="bg-slate-950 text-white font-bold px-4 py-2 rounded-xl hover:bg-slate-800 transition-colors flex items-center gap-2">
              <LayoutDashboard size={16} /> <span className="hidden sm:inline">Painel</span>
            </Link>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="bg-slate-950 text-white font-bold px-4 py-2 rounded-xl hover:bg-slate-800 transition-colors flex items-center gap-2">
              <ShieldCheck size={16} /> <span className="hidden sm:inline">Admin</span>
            </Link>
          )}
          {user && (
            <button onClick={logout} data-testid="nav-logout" title="Sair" className="text-slate-500 hover:text-slate-950 p-2 rounded-lg hover:bg-slate-100">
              <LogOut size={18} />
            </button>
          )}
        </div>
      </nav>
    </header>
  );
};
